import registrationApi from './registration-api';

export * from './registration-payload';

export default registrationApi;
